import "assets/css/common.scss";
import "assets/css/template.scss";
import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
// import "./App.css";
import ProtectedLayout from "./layout/Protected";
import PublicLayout from "./layout/Public";

import ForgotPassword from "app/containers/Public/ForgotPassword";
import Login from "app/containers/Public/Login";
import ResetPassword from "app/containers/Public/ResetPassword";
import { STORAGE } from "constant";
import { PAGE_ROUTE, PUBLIC_ROUTE } from "constant/routes/page";
import { useHandleSubmitApi } from "hook";
import { pageRoutes } from "routes";
import { AuthServices } from "services";
import TokenStorageService from "services/storage";
import { StorageUtil } from "utils/storage";
import LogoLoading from "./components/Logo";

const App: React.FC = () => {
  const accessToken = StorageUtil.getItem(STORAGE.LOCAL_ACCESS_TOKEN);
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken) {
      return navigate(PUBLIC_ROUTE.LOGIN);
    }

    (async () => {
      await verifyToken();
    })();

    //eslint-disable-next-line
  }, [accessToken]);

  const [verifyToken, loading] = useHandleSubmitApi(
    async () => {
      const refreshToken = StorageUtil.getItem(STORAGE.LOCAL_REFRESH_TOKEN);
      const dataRes = await AuthServices.verifyRefreshToken(refreshToken);
      if (dataRes) {
        if (dataRes.data.profile) {
          StorageUtil.setItem(STORAGE.LOCAL_PROFILE, dataRes.data.profile);
        }

        const pathName = StorageUtil.getItem(STORAGE.LOCAL_PATH_NAME);
        if (pathName) {
          return navigate(pathName);
        }
        return navigate(PAGE_ROUTE.ADM_INVENTORY);
      }
    },
    async () => {
      // await refreshAccessToken();
      TokenStorageService.clearToken();
      window.location.href = "/login";
    }
  );

  const [refreshAccessToken] = useHandleSubmitApi(
    async () => {
      const refreshToken = StorageUtil.getItem(STORAGE.LOCAL_REFRESH_TOKEN);
      const dataRes = await AuthServices.refreshAccessToken(refreshToken);
      if (dataRes) {
        StorageUtil.setItem(STORAGE.LOCAL_ACCESS_TOKEN, dataRes.data.accessToken);
        StorageUtil.setItem(STORAGE.LOCAL_REFRESH_TOKEN, dataRes.data.refreshToken);
        return navigate(PAGE_ROUTE.ADM_INVENTORY);
      }
    },
    () => {
      TokenStorageService.clearToken();
      window.location.href = "/login";
    }
  );

  const handleLogout = () => {
    StorageUtil.removeItem(STORAGE.LOCAL_ACCESS_TOKEN);
    StorageUtil.removeItem(STORAGE.LOCAL_PATH_NAME);
    StorageUtil.removeItem(STORAGE.LOCAL_PROFILE);
    StorageUtil.removeItem(STORAGE.LOCAL_REFRESH_TOKEN);
    StorageUtil.removeItem(STORAGE.SESSION_CURRENT_DATE);

    navigate(PUBLIC_ROUTE.LOGIN);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {loading && <LogoLoading />}
      {!loading && (
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>

          <Route path="/adm" element={<ProtectedLayout />}>
            {pageRoutes.map((i, idx) => {
              const Component = i.component;
              return (
                Component && (
                  <Route key={idx} path={i.path} element={<Component />}>
                    {i.children?.map((c, cIdx) => {
                      const ChildComponent = c.component;
                      return <Route key={i + "_" + cIdx} path={c.path} element={<ChildComponent />} />;
                    })}
                  </Route>
                )
              );
            })}
          </Route>
        </Routes>
      )}
    </Suspense>
  );
};

export default App;
